import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Tabs, Tab } from '@mui/material';
import { DocumentUpload } from '../components/documents/DocumentUpload';
import { DocumentList } from '../components/documents/DocumentList';
import { Document } from '../types/documents';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`documents-tabpanel-${index}`}
      aria-labelledby={`documents-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export const DocumentsPage: React.FC = () => {
  const [tabValue, setTabValue] = React.useState(0);
  const [selectedClientId] = React.useState('demo-client-123'); // In real app, this would come from context/route

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleUploadComplete = (document: Document) => {
    console.log('Document uploaded:', document);
    // In real app, you might want to refresh the list or show a notification
  };

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        Document Management
      </Typography>
      
      <Typography variant="body1" color="text.secondary" paragraph>
        Upload, process, and manage documents with automated OCR, categorization, and workflow processing.
      </Typography>

      <Card>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange} aria-label="documents tabs">
            <Tab label="Upload Documents" />
            <Tab label="Document Library" />
          </Tabs>
        </Box>
        
        <TabPanel value={tabValue} index={0}>
          <DocumentUpload 
            clientId={selectedClientId}
            onUploadComplete={handleUploadComplete}
          />
        </TabPanel>
        
        <TabPanel value={tabValue} index={1}>
          <DocumentList clientId={selectedClientId} />
        </TabPanel>
      </Card>

      {/* Document Processing Info */}
      <Grid container spacing={3} sx={{ mt: 4 }}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom color="primary">
                AWS Bedrock OCR
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Intelligent document processing using AWS Bedrock Claude 3.5 Sonnet for accurate text extraction and entity recognition.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid size={{ xs: 12, md: 4 }}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom color="primary">
                Auto-Categorization
              </Typography>
              <Typography variant="body2" color="text.secondary">
                AI-powered document classification automatically identifies document types and categories based on content analysis.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        
        <Grid size={{ xs: 12, md: 4 }}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom color="primary">
                Workflow Integration
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Seamless integration with the rules engine for automated processing triggers and business logic execution.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DocumentsPage;